export default __webpack_public_path__ + "static/media/logo138x75white.4b181888.png";